<template>
  <div class="homeMarketPrice HomeContainer">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/home">{{l("首页")}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{l("常用原材料价格一览")}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        {{l("时间")}}：
        <el-date-picker
          class="date"
          v-model="info_time"
          size="small"
          type="date"
          :placeholder="l('选择日期')"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="getMarketPrice"
        >
        </el-date-picker>
      </div>
    </div>
    <el-table
      v-if="marketPrice"
      key="table"
      :data="marketPrice.priceList"
      border
    >
      <el-table-column
        v-for="(title, index) of marketPrice.titleList"
        :key="index"
        :label="title"
        show-overflow-tooltip
        :fixed="index == 0"
        :min-width="190"
      >
        <template slot-scope="scope">
          <div v-if="index == 0">
            {{ scope.row[index] }}
          </div>
          <div v-else>
            {{ scope.row[index].num }}
            <span v-show="scope.row[index].plus" class="plus">
              {{ scope.row[index].plus }}
            </span>
            <span v-show="scope.row[index].minus" class="minus">
              {{ scope.row[index].minus }}
            </span>
            <span v-show="scope.row[index].fix" class="fix">
              {{ scope.row[index].fix }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-empty v-else :description="l('暂无数据')"></el-empty>
  </div>
</template>

<script>
export default {
  name: "HomeMarketPrice",
  data() {
    return {
      info_time: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      marketPrice: {
        titleList: [],
        priceList: [],
      },
    };
  },
  created() {
    this.getMarketPrice();
  },
  methods: {
    getMarketPrice() {
      this.axios
        .get("/api/website_dynamic/market_price/", {
          params: {
            info_time: this.info_time,
          },
        })
        .then((data) => {
          if (data) {
            this.marketPrice = {
              titleList: data.info[0].map(item=>this.l(item)),
              priceList: data.info.slice(1).map((origin_arr) => {
                origin_arr = origin_arr.map((item, index) => {
                  if (index == 0) {
                    return item;
                  } else {
                    var obj = {
                      num: "-",
                      plus: null,
                      minus: null,
                      fix: null,
                    };
                    var arr = String(item).split(" ");
                    obj.num = arr[0];
                    if (arr[1] && arr[1].indexOf("+") == 0) {
                      obj.plus = arr[1];
                    } else if (arr[1] && arr[1].indexOf("-") == 0) {
                      obj.minus = arr[1];
                    } else {
                      obj.fix = arr[1];
                    }
                    return obj;
                  }
                });
                return origin_arr;
              }),
            };
            this.info_time = data.info_time;
          } else {
            this.marketPrice = null;
            if (!this.info_time) {
              this.info_time = this.$utils.formatDate(new Date());
            }
          }
        });
    },
  },
};
</script>


<style scoped lang="scss">
.homeMarketPrice {
  margin-top: 15px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 30px;
    /deep/.el-breadcrumb__inner.is-link {
      font-weight: normal;
    }
  }
  .el-table {
    margin-top: 15px;
    box-shadow: none;
    /deep/.el-table__header th {
      background: $warningColor;
      color: #fff;
    }
  }
}
/deep/.el-empty {
  background: #fff;
  margin-top: 15px;
}

/deep/.plus {
  color: #ff7473;
  margin-left: 10px;
}
/deep/.minus {
  color: #099d08;
  margin-left: 10px;
}
/deep/.fix {
  margin-left: 10px;
}
</style>

